import React from 'react';
import classNames from 'classnames';
import styles from '../assets/districts-grid.module.scss';
import { Paginated } from 'src/services/api-handlers/pagination';
import Grid, { Column } from 'src/components/react-table/Grid';
import textFilter from 'src/components/react-table/filters/text-filter';
import { QueryParams } from 'src/types/grid';
import { IDistrict } from 'src/types/district';
import DetailDistrictColumn from './DetailDistrictColumn';
import DistrictActionsColumn from './DistrictActionsColumn';
import { CellProps } from 'react-table';

import dateTimeFilter from 'src/components/react-table/filters/datetime-filter';
import { changeToZeroMoment } from '../../../../../../../helpers/timeHelpers';

interface Props {
    data: Paginated<IDistrict>;
    getData: (params: QueryParams) => void;
}

const columns: Column<IDistrict>[] = [
    {
        Header: 'Name',
        accessor: 'name',
        Cell: DetailDistrictColumn,
        Filter: textFilter<IDistrict>(),
    },
    {
        Header: 'Address',
        accessor: 'address',
        disableSortBy: true,
        Filter: textFilter<IDistrict>(),
    },
    {
        Header: 'Contact',
        accessor: 'contact',
        disableSortBy: true,
        Filter: textFilter<IDistrict>(),
    },
    {
        Header: 'Email',
        accessor: 'email',
        disableSortBy: true,
        Filter: textFilter<IDistrict>(),
    },
    {
        Header: 'Phone',
        accessor: 'phone',
        disableSortBy: true,
        Filter: textFilter<IDistrict>(),
    },
    {
        Header: 'Additional',
        accessor: 'info',
        width: '15%',
        disableSortBy: true,
        Filter: textFilter<IDistrict>(),
    },
    {
        Header: 'Created',
        accessor: 'createdAt',
        width: '15%',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IDistrict>) => changeToZeroMoment(original.createdAt, 'MMM DD, YYYY'),
        Filter: dateTimeFilter<IDistrict>(),
    },
    {
        Header: 'Actions',
        accessor: 'districtDocs',
        Cell: DistrictActionsColumn,
        disableSortBy: true,
        disableFilters: true,
        width: '10%',
    },
];

const DistrictsGrid: React.FunctionComponent<Props> = ({ data, getData }: Props) => (
    <div className={classNames(styles.grid)}>
        <Grid<IDistrict> columns={columns} data={data} getData={getData} />
    </div>
);

export default DistrictsGrid;
